import * as React from 'react'
import * as classes from './Social.module.scss'
import cn from 'classnames'
import IconYouTube from './IconYouTube'
import IconFb from './IconFb'
import IconLinkedin from './IconLinkedin'
import IconInsta from './IconInsta'

function Social({ fb, linkedin, inst, youTube, className }) {
    return (
        <div className={cn(classes.Social, className)}>
            {inst.url && (
                <a className={classes.Link} href={`${inst.url}`} target='_blank' rel='noopener noreferrer'>
                    <IconInsta width={inst?.sizes?.width} height={inst?.sizes?.height} styles={inst?.styles} />
                </a>
            )}

            {fb.url && (
                <a className={classes.Link} href={`${fb.url}`} target='_blank' rel='noopener noreferrer'>
                    <IconFb width={fb?.sizes?.width} height={fb?.sizes?.height} styles={fb?.styles} />
                </a>
            )}

            {youTube.url && (
                <a className={classes.Link} href={`${youTube.url}`} target='_blank' rel='noopener noreferrer'>
                    <IconYouTube width={youTube?.sizes?.width} youTube={youTube?.sizes?.height} styles={youTube?.styles} />
                </a>
            )}

            {linkedin.url && (
                <a className={classes.Link} href={`${linkedin.url}`} target='_blank' rel='noopener noreferrer'>
                    <IconLinkedin width={linkedin?.sizes?.width} height={linkedin?.sizes?.height} styles={linkedin?.styles} />
                </a>
            )}
        </div>
    )
}

export default Social
